import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import MovieIcon from '@mui/icons-material/Movie';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShieldIcon from '@mui/icons-material/Shield';
import BuildIcon from '@mui/icons-material/Build';
import SportsIcon from '@mui/icons-material/Sports';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SendIcon from '@mui/icons-material/Send';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import FlagIcon from '@mui/icons-material/Flag';
import CallMadeIcon from '@mui/icons-material/CallMade';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CachedIcon from '@mui/icons-material/Cached';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import GavelIcon from '@mui/icons-material/Gavel';
import PanToolIcon from '@mui/icons-material/PanTool';
import BlockIcon from '@mui/icons-material/Block';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

const tagIcons = {
    'Game Highlight': MovieIcon,
    'Clean Game': PlayCircleIcon,
    'All Offensive Possessions': TrendingUpIcon,
    'All Defensive Possessions': ShieldIcon,
    'Build Up Opponent Half': TrendingUpIcon,
    'Build Up Own Half': BuildIcon,
    'Build Up Goalkeeper': SportsIcon,
    'Started From Goalkeeper': GpsFixedIcon,
    'Counter-Attacks': FlashOnIcon,
    'Started From Interception': SwapHorizIcon,
    'Started From Tackle': FitnessCenterIcon,
    'Started From Throw In': SendIcon,
    'Goals': EmojiEventsIcon,
    'Chances': AdsClickIcon,
    'Free Kicks': SportsSoccerIcon,
    'Corners': FlagIcon,
    'Crosses': CallMadeIcon,
    'Draw Fouls': ReportProblemIcon,
    'Turnovers': CachedIcon,
    'Offsides': DoNotDisturbIcon,
    'Penalties Gained': GavelIcon,
    'Saved': PanToolIcon,
    'Blocked': BlockIcon,
    'Clearance': CleaningServicesIcon
};

const tagColors = {
    'Game Highlight': '#6366f1',
    'Clean Game': '#8b5cf6',
    'All Offensive Possessions': '#22c55e',
    'All Defensive Possessions': '#3b82f6',
    'Build Up Opponent Half': '#f59e0b',
    'Build Up Own Half': '#06b6d4',
    'Build Up Goalkeeper': '#14b8a6',
    'Started From Goalkeeper': '#10b981',
    'Counter-Attacks': '#ef4444',
    'Started From Interception': '#ec4899',
    'Started From Tackle': '#f97316',
    'Started From Throw In': '#84cc16',
    'Goals': '#eab308',
    'Chances': '#a855f7',
    'Free Kicks': '#0ea5e9',
    'Corners': '#f43f5e',
    'Crosses': '#6366f1',
    'Draw Fouls': '#f97316',
    'Turnovers': '#64748b',
    'Offsides': '#94a3b8',
    'Penalties Gained': '#dc2626',
    'Saved': '#16a34a',
    'Blocked': '#0891b2',
    'Clearance': '#7c3aed'
};

const GameTagCard = ({ isSelected, tagname, onShow, t, isLoading }) => {
    const Icon = tagIcons[tagname] || SportsSoccerIcon;
    const color = tagColors[tagname] || '#6366f1';

    return (
        <Box
            onClick={onShow(tagname)}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '12px 8px',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                backgroundColor: isSelected ? color : '#f9fafb',
                border: `1px solid ${isSelected ? color : '#e5e7eb'}`,
                boxShadow: isSelected
                    ? `0 2px 8px ${color}35`
                    : 'none',
                '&:hover': {
                    borderColor: color,
                    backgroundColor: isSelected ? color : `${color}08`,
                    transform: 'translateY(-1px)'
                },
                minHeight: '72px'
            }}
        >
            <Box
                sx={{
                    width: 32,
                    height: 32,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: isSelected ? 'rgba(255,255,255,0.2)' : `${color}12`,
                    marginBottom: '6px'
                }}
            >
                {isLoading ? (
                    <CircularProgress size={18} sx={{ color: isSelected ? '#ffffff' : color }} />
                ) : (
                    <Icon sx={{
                        fontSize: 18,
                        color: isSelected ? '#ffffff' : color
                    }} />
                )}
            </Box>
            <Typography
                sx={{
                    fontSize: '11px',
                    fontWeight: 600,
                    color: isSelected ? '#ffffff' : '#4b5563',
                    textAlign: 'center',
                    lineHeight: 1.2,
                    maxWidth: '100%'
                }}
            >
                {t(tagname)}
            </Typography>
        </Box>
    );
};

export default GameTagCard;
